import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {required} from "../../utility/validators";
import {AbstractComponent} from "../abstract.component";
import {DiscountItem} from "../../model/discounts";

@Component({
    selector: 'add-discount-item-modal',
    templateUrl: './add-discount-item-modal.component.html',
    styleUrls: ['./add-discount-item-modal.component.scss'],
    standalone: false
})
export class AddDiscountItemModalComponent extends AbstractComponent implements OnInit {

  inputForm = new FormGroup({
    numberOfRaces: new FormControl(),
    amount: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.inputForm.controls.numberOfRaces.addValidators([required]);
    this.inputForm.controls.amount.addValidators([required]);
    this.inputForm.updateValueAndValidity();
  }

  onConfirmClick(): void {
    this.activeModal.close(new DiscountItem(this.inputForm.controls.numberOfRaces.value, this.inputForm.controls.amount.value));
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}
